import React from 'react';
import { Box, Grid, Typography, Container, Button, Stack, useTheme,styled } from '@mui/material';
import about from '../images/whoAreWe.png';
import aboutUS from '../images/aboutUS.jpg';
import mission from '../images/mission.png';
import vision from '../images/vision.png';

// Assume you have a similar image for the final CTA, or use a color overlay
import back1 from '../images/tm.jpg';

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    borderRadius: '50px',
    backgroundColor: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: theme.shadows[3],
    transition: 'background-color 0.3s, transform 0.3s, color 0.3s', // Added 'color 0.3s'
    '&:hover': {
        backgroundColor: '#a974d0', // Changed hover background color
        color: '#fff', // Added hover text color
        transform: 'translateY(-2px)',
    },
}));

function AboutUs() {
  const theme = useTheme();

  return (
    <>
      {/* Hero Section */}
      <Box
        sx={{
          height: { md: '60vh', xs: '40vh' },
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${about})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          textAlign: 'center',
          p: 2,
        }}
        className='no-select'
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: '600',
            fontSize: { xs: '3rem', md: '6rem' },
            mb: 2,
          }}
        >
          Who Are We
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: '500',
            fontSize: { xs: '0.875rem', md: '1.2rem' },
          }}
        >
          <a href='/' style={{ textDecoration: 'none', color: 'white' }}>Home</a> / <span style={{ color: theme.palette.primary.main }}>Who Are We</span>
        </Typography>
      </Box>

      {/* About CC Software Solutions Section */}
      <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={aboutUS}
              alt='About CC Software Solutions'
              sx={{
                width: '100%',
                height: 'auto',
                aspectRatio: '3 / 2',
                objectFit: 'cover',
                borderRadius: '8px',
                boxShadow: theme.shadows[4],
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
                <Typography
                variant="h3"
                component="h2"
                sx={{
                    fontWeight: 'bold',
                    color: theme.palette.text.primary,
                    textAlign: { xs: 'center', md: 'left' }
                }}
                >
                Who are we?
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        color: theme.palette.text.secondary,
                        textAlign: 'justify'
                    }}
                    >
                    CC Software Solutions, an innovative IT company based in Sri Lanka, is dedicated to empowering businesses through cutting-edge technology and strategic digital marketing. We specialize in <strong>web development</strong>, <strong>mobile app development</strong>, <strong>digital marketing</strong>, and <strong>digital product design</strong>, providing comprehensive solutions that cater to the unique needs of our clients.
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        color: theme.palette.text.secondary,
                        textAlign: 'justify'
                    }}
                    >
                    At CC Software Solutions, we pride ourselves on delivering next-gen software solutions and digital marketing consultancy that drive growth and success for businesses of all sizes. Our expert team leverages Sri Lanka's low-cost advantages to offer customized and cost-effective services, ensuring that our clients receive the best value for their investment. Our client-focused approach and advanced methodologies enable us to serve a diverse clientele effectively. We are committed to helping organizations and small-scale businesses thrive in today's competitive landscape through innovative software solutions and strategic digital marketing.
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        color: theme.palette.text.secondary,
                        textAlign: 'justify'
                    }}
                    >
                    Our strengths lie in our skilled and experienced team, who bring a wealth of expertise to every project. We understand the intricacies of digital transformation and are dedicated to providing top-notch services that meet and exceed our clients' expectations. Join us at CC Software Solutions, where we turn your vision into reality with our comprehensive and client-centric approach to digital innovation.
                </Typography>

                        </Stack>
                    </Grid>
                    </Grid>
                </Container>

                {/* Mission and Vision Section */}
                <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
                    <Grid container spacing={6}>
                    <Grid item xs={12} md={6}>
                        <Stack
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            p: 4,
                            borderRadius: '8px',
                            height: '100%',
                            boxShadow: theme.shadows[2],
                            borderLeft: `5px solid ${theme.palette.primary.main}`,
                        }}
                        >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
                            Our Vision
                            </Typography>
                            <Box component="img" src={vision} alt='Vision' sx={{ width: '50px', height: '50px', ml: 2 }} />
                        </Box>
                        <Typography variant="body1" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'center' }}>
                            "To be the leading software solutions provider in Sri Lanka, recognized for our cutting-edge technology, unparalleled customer satisfaction, and our ability to drive business success through innovation and excellence. We aim to create a digital future where businesses of all sizes can thrive and grow with our support."
                        </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Stack
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            p: 4,
                            borderRadius: '8px',
                            height: '100%',
                            boxShadow: theme.shadows[2],
                            borderLeft: `5px solid ${theme.palette.secondary.main}`,
                        }}
                        >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
                            Our Mission
                            </Typography>
                            <Box component="img" src={mission} alt='Mission' sx={{ width: '50px', height: '50px', ml: 2 }} />
                        </Box>
                        <Typography variant="body1" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'center' }}>
                            "To deliver innovative, reliable, and user-friendly software solutions that empower businesses to achieve their full potential. We are committed to providing exceptional customer service, fostering a culture of continuous improvement, and maintaining a focus on quality and integrity in everything we do."
                        </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      {/* Our Values Section */}
      <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{ fontWeight: 'bold', color: theme.palette.text.primary, textAlign: 'center', mb: 6 }}
        >
          Our Values
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'center', mb: 4 }}
        >
          At CC Software Solutions, our values are the cornerstone of our success. We pride ourselves on having a skilled, young, and enthusiastic team that brings creativity and passion to software development and digital marketing services. We believe that integrity is crucial to achieving greatness, and we motivate and encourage everyone around us to strive for excellence. Valuing our relationships within the team and fostering collaboration with all our stakeholders is paramount. We treat every client with the utmost respect and dedication, regardless of the size of their business, and are committed to delivering top-notch products and services that exceed expectations.
        </Typography>
        
        {/* Why Choose Us Section */}
        <Typography
          variant="h3"
          component="h2"
          sx={{ fontWeight: 'bold', color: theme.palette.text.primary, textAlign: 'center', mt: 8, mb: 4 }}
        >
          Why should you work with us?
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'center', mb: 6 }}
        >
          Working with CC Software Solutions provides a range of compelling incentives. Our collaboration promises valuable benefits and opportunities, including:
        </Typography>

        <Grid container spacing={4}>
          {renderValueCard('Skilled, Enthusiastic Team', 'Our team is composed of skilled, young professionals who bring a high level of enthusiasm to every project. Their expertise and innovative thinking ensure that we deliver cutting-edge solutions.')}
          {renderValueCard('Creativity and Passion', 'We are passionate about software development and digital marketing services. Our team’s creativity drives us to develop unique and effective solutions tailored to meet each client’s specific needs.')}
          {renderValueCard('Commitment to Integrity', 'We believe that integrity is crucial to achieving greatness. Our commitment to honesty and transparency fosters trust and builds strong, lasting relationships with our clients.')}
          {renderValueCard('Striving for Excellence', 'We motivate and encourage our team to strive for excellence in all that they do. This culture of continuous improvement ensures that we consistently deliver high-quality results.')}
          {renderValueCard('Valuing Relationships and Collaboration', 'We place a high value on our relationships within the team and with our clients. Collaboration is at the heart of our approach, ensuring that we work closely with all stakeholders to achieve the best outcomes.')}
          {renderValueCard('Equal Treatment of Clients', 'At CC Software Solutions, every client is treated with the utmost respect and dedication, regardless of the size of their business. We believe that every client deserves our best efforts and top-notch service.')}
        </Grid>
      </Container>
      
       {/* Contact section */}
            <Box
                sx={{
                    height: '35vh',
                    backgroundImage: `url(${back1})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#fff',
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: '500',
                            fontSize: { md: '6rem', xs: '4rem' },
                        }}
                    >
                        Let's Start
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: '700',
                            fontSize: { md: '1.25rem', xs: '1rem' },
                            mt: 2
                        }}
                        >
                        Empowering businesses through custom software solutions.{' '}
                        <span style={{ color: '#a974d0' }}>Your success, our code.</span>
                    </Typography>

                    <StyledButton href="/contactus">Get In Touch</StyledButton>
                </Box>
            </Box>
    </>
  );
}

// Helper function to render a single value card
const renderValueCard = (title, content) => (
  <Grid item xs={12} md={4}>
    <Stack
      alignItems="center"
      sx={{
        p: 3,
        textAlign: 'center',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: '8px',
        height: '100%',
        transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
        '&:hover': {
          boxShadow: 8,
          transform: 'translateY(-5px)',
        },
      }}
    >
      <Typography variant="h5" component="h4" sx={{ fontWeight: 'bold', color: 'black', mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'Montserrat, sans-serif', color: 'grey.700' }}>
        {content}
      </Typography>
    </Stack>
  </Grid>
);

export default AboutUs;